import ChangePage from './ChangePage'
import WorkQueuesControls from './WorkQueuesControls'
import classes from './WorkQueuesHeader.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { filterActions } from '../../../store/filter'
import { useEffect, useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { getUserWorkQueueViews } from '../../../lib/fetchApi'
import { retrieveSpecificWorkQ } from '../../../lib/systemData'
import { getItemFromStorageSimple } from '../../../lib/script'
import { currentMatchesSavedWorkQueueView, savedViewDiffersFromWorkQDefaults } from '../../../lib/filters'

const WorkQueuesHeader = ({page}) => {

    const dispatch = useDispatch()
    const { workqSlug } = useParams()
    const settingsRevision = useSelector((state) => state.system.settingsRevision)
    const savedViewsLoaded = useSelector((state) => state.filter.savedViewsLoaded)
    const token = useSelector((state) => state.user.token) || (typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null)
    const filters = useSelector((state) => state.filter.filters)
    const exceptions = useSelector((state) => state.filter.exceptions)
    const savedView = useSelector((state) => (
        workqSlug ? state.filter.savedViewsBySlug?.[workqSlug] : null
    ))
    const workQ = useMemo(() => {
        const slug = workqSlug || 'police-report'
        return retrieveSpecificWorkQ(slug)
    }, [workqSlug, settingsRevision])
    const userLocations = getItemFromStorageSimple('userLocations')
    const showSavedFilterNotice = currentMatchesSavedWorkQueueView(workQ, filters, exceptions, savedView)
        && savedViewDiffersFromWorkQDefaults(workQ, savedView, userLocations)

    useEffect(() => {
        if (!token || savedViewsLoaded) {
            return
        }
        let cancelled = false
        getUserWorkQueueViews(token).then((savedViews) => {
            if (cancelled) {
                return
            }
            dispatch(filterActions.setSavedViews(
                savedViews && !savedViews.errorMessage && savedViews.views
                    ? savedViews.views
                    : {}
            ))
        }).catch(() => {
            if (!cancelled) {
                dispatch(filterActions.setSavedViews({}))
            }
        })
        return () => {
            cancelled = true
        }
    }, [token, savedViewsLoaded, dispatch])

    useEffect(() => {     
        return () => {
            dispatch(filterActions.setFiltersMultiple(null))
            dispatch(filterActions.setExceptionsBatch({}))
            dispatch(filterActions.setCurrentPage(1))
            dispatch(filterActions.setActiveSavedViewSlug(null))
        }
    }, [dispatch])

    return (
        <div className={classes.controls_outer_container}>
            <ChangePage />
            <div className={classes.controls_right}>
                {showSavedFilterNotice && (
                    <div className={classes.saved_filter_notice}>
                        Saved filter applied. Click Reset to revert to original.
                    </div>
                )}
                <WorkQueuesControls page={page}/>
            </div>
        </div>
    )
}

export default WorkQueuesHeader